// register component(s) with react habitat
import withLazyUnveil from '@src/scripts/hoc/withLazyUnveil';

export default {
	SknrwContactForm: withLazyUnveil( {
		loadComponent: () =>
			import(
				/* webpackChunkName: "SknrwContactForm" */
				'./index'
			),
		// height: 1277,
		// mobileHeight: 1440,
	} ),
};
